import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { fileUrl } from "../lib/seo";

const money = (v) => `$${(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export default function SevaFundSection() {
  const [d, setD] = useState(null);
  const [partners, setPartners] = useState([]);
  useEffect(() => {
    api.get("/seva-fund").then((r) => setD(r.data));
    api.get("/ngos/partners").then((r) => setPartners(r.data.items.filter((n) => n.logo_on_transparency)));
  }, []);
  if (!d) return null;
  return (
    <section data-testid="seva-fund-section" className="mt-16">
      <div className="overline">Seva Fund</div>
      <h2 className="font-serif text-3xl md:text-4xl text-[#4A0E17] mt-2">{d.fee_share_percent}% of every platform fee goes back to society</h2>
      <p className="text-[#63534E] mt-3 max-w-2xl">This money funds projects run by verified <Link to="/ngo" className="text-[#E65100]">NGO partners</Link> and <Link to="/scholarships" className="text-[#E65100]">student scholarships</Link>. Every grant is listed here.</p>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
        {[["Collected so far", d.accrued, "fund-accrued"], ["Granted", d.granted, "fund-granted"], ["Paid out", d.disbursed, "fund-disbursed"], ["Available", d.available, "fund-available"]].map(([l, v, t]) => (
          <div key={l} data-testid={t} className="bg-[#FFFDF9] sacred-border rounded-2xl p-5"><div className="font-mono text-2xl text-[#4A0E17]">{money(v)}</div><div className="overline mt-1">{l}</div></div>
        ))}
      </div>
      <div className="mt-8 grid lg:grid-cols-2 gap-6">
        <GrantList title="NGO projects funded" empty="No projects funded yet." rows={d.projects.map((p) => [p.id, p.title, `${p.ngo_name} · ${p.beneficiaries} beneficiaries`, p.amount_granted_usd, p.status])} />
        <GrantList title="Students sponsored" empty="No scholarships awarded yet." rows={d.students.map((s) => [s.id, s.student, s.course, s.amount_granted_usd, s.status])} />
      </div>
      {partners.length > 0 && (
        <div data-testid="fund-partner-logos" className="mt-8 flex flex-wrap items-center gap-6">
          <span className="overline">Seva Stambh partners</span>
          {partners.map((n) => n.logo_url ? <img key={n.id} src={fileUrl(n.logo_url)} alt={n.org_name} title={n.org_name} className="h-12 w-12 rounded-full object-cover" />
            : <span key={n.id} className="font-serif text-[#4A0E17]">{n.org_name}</span>)}
        </div>
      )}
    </section>
  );
}

function GrantList({ title, rows, empty }) {
  return (
    <div className="bg-[#FFFDF9] sacred-border rounded-2xl p-6">
      <h3 className="font-serif text-xl text-[#4A0E17]">{title}</h3>
      <div className="mt-4 divide-y divide-[#D4AF37]/25">
        {rows.length === 0 && <div className="text-sm text-[#63534E]">{empty}</div>}
        {rows.map(([id, a, b, amt, st]) => (
          <div key={id} className="py-3 flex items-center gap-3">
            <div className="flex-1 min-w-0"><div className="font-semibold text-[#4A0E17] truncate">{a}</div><div className="text-xs text-[#63534E] truncate">{b}</div></div>
            <div className="text-right"><div className="font-mono text-sm">{money(amt)}</div><div className="text-[10px] uppercase tracking-wider text-[#8C6D3B]">{st}</div></div>
          </div>
        ))}
      </div>
    </div>
  );
}
